import { LocalTime } from '@js-joda/core';

import { FormContextValues } from '@dreryk/react-common';

import { AvailabilityCreationFormBean } from '../availabilityCreation/availabilityCreation.types';
import { AvailabilityUpdateFormBean } from '../availabilityUpdate/availabilityUpdate.types';

export enum RecurrencePeriod {
   NONE = 'NONE',
   EVERY_WEEK = 'EVERY_WEEK',
   EVERY_TWO_WEEKS = 'EVERY_TWO_WEEKS',
}

export enum FormType {
   UPDATE = 'UPDATE',
   CREATION = 'CREATION',
}

export enum TimePickerRangeType {
   END = 'END',
   START = 'START',
}

export type AdjustStartTimeOrEndTime = (
   rangeType: TimePickerRangeType,
   value: LocalTime,
   stepInMinutes: number
) => void;

export type ValueOf<T> = T[keyof T];
export type RecurrencePeriodUnion = ValueOf<typeof RecurrencePeriod>;

export type AvailabilityFormController = FormContextValues<AvailabilityCreationFormBean | AvailabilityUpdateFormBean>;
